import React from 'react'
import './index.css'
import logUtil from 'utils/log'
import H3 from 'components/H3'
import ButtonTextPrimary from 'components/ButtonTextPrimary'
import Image from 'components/Image'
import useDispatch from 'hooks/use-dispatch'
import updateCurrentToastAction from 'modules/toast/redux/actions/update-current'
import Link from 'components/Link'
import getUrlProductUtil from 'modules/product/utils/get-url'
import getMessageErrorUtil from 'modules/error/utils/get-message'
import FlexColumn from 'components/FlexColumn'
import Flex from 'components/Flex'
import P from 'components/P'
import HoverUnderlined from 'components/HoverUnderlined'
import getSrcSetImageUtil from 'components/Image/utils/get-src-set'
import getHighQualityImageProductUtil from 'modules/product/utils/get-high-quality-image'

import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import openQuickShopSidebarProductAction from 'modules/product/redux/actions/open-quick-shop-product-sidebar'

import isArchivedProductVariantUtil from 'modules/product-variant/utils/is-archived/index.js'

import hasSampledProductAction from 'modules/product/redux/actions/has-sampled'
import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'
import useSelector from 'hooks/use-selector'
import addItemCartAction from 'modules/cart/redux/actions/add-item'

const ADD_TO_CART = 'Add to cart'
const TITLE = 'Most recent like'
const ADDED_TO_CART = 'Sample added to cart'
const ALREADY_SAMPLED = 'Already sampled'
const PRODUCT_OUT_OF_STOCK = 'Product out of stock'

export default function MostRecentLikedSample (props) {
  const dispatch = useDispatch()
  const debugProps = {
    props
  }
  /**
   * @type ProductVariantCarouselInfo
   */
  const mostRecentLikedSample = props.mostRecentLikedSample
  logUtil('MostRecentLikedSample').debug('debugProps=', debugProps)

  const variantId = mostRecentLikedSample.variant_id

  const hasSampled = useSelector(hasSampledVariantSelector(variantId))
  // TODO handle adding multiple samples to cart
  const handleClickAddToCart = async () => {
    logUtil('MostRecentLikedSample#handleClickAddToCart').debug('[start]')
    try {
      if (!mostRecentLikedSample?.available) {
        dispatch(updateCurrentToastAction(PRODUCT_OUT_OF_STOCK))
        return
      }

      if (hasSampled) {
        dispatch(updateCurrentToastAction(ALREADY_SAMPLED))
        return
      }

      await dispatch(addItemCartAction({ variantId: mostRecentLikedSample.variant_id }))
      dispatch(updateCurrentToastAction(ADDED_TO_CART))
    } catch (error) {
      const errorMessage = getMessageErrorUtil(error)
      logUtil('MostRecentLikedSample#handleClickAddToCart').debug(`errorMessage=${errorMessage}`)
      dispatch(updateCurrentToastAction(errorMessage))
    }
  }

  React.useEffect(() => {
    dispatch(
      hasSampledProductAction({
        productIds: [mostRecentLikedSample?.product_id]
      })
    )
  }, [mostRecentLikedSample])

  const handleClickItem = (event, sampleProduct) => {
    event.preventDefault()

    dispatch(updateCurrentProductIdAction(sampleProduct.product_id))
    dispatch(updateCurrentVariantIdAction(sampleProduct.variant_id))

    addProductAndVariantIdToUrlProductUtil({
      productId: sampleProduct.product_id,
      variantId: sampleProduct.variant_id
    })

    dispatch(openQuickShopSidebarProductAction())
  }

  const url = getUrlProductUtil(mostRecentLikedSample.handle, variantId)
  const isArchivedProduct = isArchivedProductVariantUtil(mostRecentLikedSample)
  const image = mostRecentLikedSample.image_url

  const handleClick = (e) => {
    e.preventDefault()
    if (isArchivedProduct) {
      return
    }

    handleClickItem(e, mostRecentLikedSample)
  }

  return (
    <Flex
      className='squad-most-recent-liked-sample'

    >
      <FlexColumn
        className='squad-most-recent-liked-sample-text'
      >
        <FlexColumn
          className='squad-most-recent-liked-sample-text-content'

        >
          <H3>{TITLE}</H3>
          <P>
            <Link
              onClick={(e) => { handleClickItem(e, mostRecentLikedSample) }}
              href={url}
            >
              <HoverUnderlined>{mostRecentLikedSample?.title}</HoverUnderlined>
            </Link>
          </P>
          <ButtonTextPrimary onClick={handleClickAddToCart}>{isArchivedProduct ? PRODUCT_OUT_OF_STOCK : ADD_TO_CART}</ButtonTextPrimary>
        </FlexColumn>
      </FlexColumn>
      <FlexColumn
        className='squad-most-recent-liked-sample-image'
      >
        <Link
          onClick={handleClick}
          href={url}
        >
          <Image
            src={image}
            srcSet={getSrcSetImageUtil(getHighQualityImageProductUtil(image))}
            alt={mostRecentLikedSample.title}
          />
        </Link>
      </FlexColumn>
    </Flex>
  )
}
